// Shared by the cart popup, full cart page, and product page's dynamic
// checkout button. Keeps a customer from ever reaching /checkout with a
// cart below the shipping-efficient minimum — the checkout Function still
// enforces this too, but by the time a customer sees THAT message they've
// already generated an abandoned checkout record. Gating the button here
// stops that from happening for the common case (a normal click through
// the storefront), while the Function remains the backend safety net for
// anything that reaches checkout by another path.
//
// Thresholds mirror extensions/checkout-rules-validation/src/cart_validations_generate_run.js
// exactly (MIN_SUBTOTAL_BY_CURRENCY) — keep the two in sync if either changes.
window.MinimumOrderGate = (function () {
  var MIN_SUBTOTAL_BY_CURRENCY = { CAD: 6.25, USD: 5.25, AUD: 7.25, GBP: 4.25 };
  var CURRENCIES_WITH_CENTS = ['CAD', 'USD'];
  var CURRENCY_SYMBOLS = { CAD: '$', USD: '$', AUD: '$', NZD: '$', GBP: '£', EUR: '€', JPY: '¥' };

  function belowMinimum(cart) {
    var threshold = MIN_SUBTOTAL_BY_CURRENCY[cart.currency];
    if (threshold === undefined) return null;
    return cart.items_subtotal_price / 100 <= threshold ? threshold : false;
  }

  function messageFor(threshold, currency) {
    var symbol = CURRENCY_SYMBOLS[currency] || '';
    var amount = CURRENCIES_WITH_CENTS.indexOf(currency) !== -1
      ? threshold.toFixed(2)
      : Math.ceil(threshold).toString();
    return 'To make the most of your shipping cost, we have a ' + symbol + amount + ' ' +
      currency + ' minimum per order. Add another item to keep going!';
  }

  // cache: 'no-store' matters here — Safari in particular can otherwise
  // serve a cached response for repeat fetches to the same URL, which
  // would make this always report the SAME (stale) cart state no matter
  // how many times it's called, regardless of anything else being correct.
  function fetchCart() {
    return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); });
  }

  // Calls handler(cart) immediately (on the current cart) and again every
  // time something dispatches a 'cart:updated' event on document — every
  // cart mutation in this theme dispatches that after it settles.
  //
  // Two 'cart:updated' events can fire close together (e.g. clicking "Add
  // to Cart" twice quickly), each kicking off its own /cart.js fetch. On a
  // slow or variable connection those can resolve out of order — the
  // response for the FIRST click can land after the response for the
  // SECOND, and without guarding against that, the stale first result
  // would overwrite the correct, newer state. The token check below
  // discards any response that isn't from the most recently started
  // request, so a late-arriving stale response never wins.
  function subscribe(handler) {
    var latestToken = 0;
    function run() {
      var token = ++latestToken;
      fetchCart().then(function (cart) {
        if (token !== latestToken) return;
        handler(cart);
      });
    }
    document.addEventListener('cart:updated', run);
    run();
  }

  return { belowMinimum: belowMinimum, messageFor: messageFor, fetchCart: fetchCart, subscribe: subscribe };
})();
